module.exports = __webpack_public_path__ + "static/hero-products-0f57a71e5b249ee3d133a7b1b5726cbc.svg";